import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../utils/apiClient';
import { saveAuthSession } from '../utils/authStorage';
import './AuthLayout.css';

const InviteHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('validating'); // validating, success, error
  const [message, setMessage] = useState('Validating magic link...');

  useEffect(() => {
    const validateInvite = async () => {
      try {
        const token = searchParams.get('token');

        if (!token) {
          setStatus('error');
          setMessage('No token provided. Please use a valid magic link.');
          return;
        }

        // Call backend to validate token
        // Note: The backend route is /invite (not /api/invite) for direct access
        // Use API_BASE_URL from apiClient which handles both localhost and production
        const apiUrl = API_BASE_URL || process.env.REACT_APP_API_URL || 'https://maintenance.vajraglobal.com';
        const response = await fetch(`${apiUrl}/invite?token=${encodeURIComponent(token)}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        if (data?.success) {
          // Save session
          saveAuthSession({
            token: data.token,
            user: data.user,
          });

          setStatus('success');
          setMessage('Magic link validated! Redirecting...');

          // Redirect after short delay
          setTimeout(() => {
            const redirectUrl = data.redirectUrl || '/';
            navigate(redirectUrl, { replace: true });
          }, 1000);
        } else {
          setStatus('error');
          setMessage(data?.message || 'Failed to validate magic link.');
        }
      } catch (error) {
        console.error('[INVITE] Validation error:', error);
        const errorMessage = error.message || 'Failed to validate magic link. Please try again.';
        setStatus('error');
        setMessage(errorMessage);
      }
    };

    validateInvite();
  }, [searchParams, navigate]);

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h1>Validating Access</h1>
        {status === 'validating' && (
          <>
            <p className="auth-subtitle">{message}</p>
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <div className="spinner" style={{ margin: '0 auto' }}></div>
            </div>
          </>
        )}
        {status === 'success' && (
          <>
            <p className="auth-subtitle" style={{ color: '#28a745' }}>
              {message}
            </p>
            <div style={{ textAlign: 'center', marginTop: '2rem' }}>
              <div className="spinner" style={{ margin: '0 auto' }}></div>
            </div>
          </>
        )}
        {status === 'error' && (
          <>
            <p className="auth-subtitle" style={{ color: '#dc3545' }}>
              {message}
            </p>
            <div style={{ marginTop: '2rem', textAlign: 'center' }}>
              <button
                onClick={() => navigate('/login')}
                style={{
                  padding: '0.75rem 1.5rem',
                  backgroundColor: '#2271b1',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '1rem',
                }}
              >
                Go to Login
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InviteHandler;

